export function trackKlaviyoEvent(event, properties) {
  if (event && Array.isArray(window._learnq)) {
    if (properties) {
      window._learnq.push(["track", event, properties]);
    } else {
      window._learnq.push(["track", event]);
    }
  }
}
